import React, { FC } from 'react';
import { toast } from 'react-toastify';
import { useSendForCustomerApprovalMutation } from '../../api/projectsApi';
import Form from '../../components/Form/Form';
import { ValidatorsE } from '../../components/Form/yupValidations';
import { P } from '../../components/Text/Text';
import { FormFieldT } from '../../models/models';

import styles from './sendForCustomerApproval.module.scss';

type SendForCustomerApprovalPropTypes = {
    removePopup: () => void;
    campaignId: number;
}

const SendForCustomerApproval: FC<SendForCustomerApprovalPropTypes> = (props) => {
    const { removePopup, campaignId } = props;
    const fields: FormFieldT[] = [
        {
            label: 'Email', validation: ValidatorsE.EMAIL_LIST,
            extraContent: () => (
                <P className={styles.emailHint}>Add more addresses with commas.</P>
            ),
        },
        { label: 'Message', type: 'textarea' },
    ];
    const [sendForCustomerApproval] = useSendForCustomerApprovalMutation();

    const handleSubmit = async (data: any) => {
        const body = {
            Id: campaignId,
            Email: data.email,
            ExtraText: data.message,
            ProjectType: "VideoAd",
        };

        try {
            const res = await sendForCustomerApproval(body);
            toast('Successfully sent', {
                type: 'success',
            });
            removePopup();
        } catch (e: any) {
            console.log(e);
        }
    };

    return (
        <div>
            <P className={styles.notice}>
                You are about to share the project page with the advertiser. The advertiser will be able, independently, to approve the project for delivery to the broadcasters.
            </P>
            <Form
                onSubmit={handleSubmit}
                fields={fields}
                formID='send-for-customer-approval'
                columns={1}
            />
        </div>
    );
};

export default SendForCustomerApproval;